module.exports = __webpack_public_path__ + "front/img/kv.36b07c62.png";